import z from "zod";

export function ReqiuredNonEmptyString(emptyVal: string, missingVal?: string){
    return z.string({
        error: (ctx) => { return !ctx.input ? (missingVal ?? emptyVal) : void(0); }
    }).trim().nonempty(emptyVal)
};